<!-- Show only when uploading -->
<div *ngIf="spinner" class="progress-overlay">
  <div class="progress-container">
    <div class="spinner-circle">
      <svg>
        <!-- Background Circle -->
        <circle class="bg" cx="60" cy="60" r="54"></circle>

        <!-- Foreground Progress Circle, dynamic offset -->
        <circle
          cx="60"
          cy="60"
          r="54"
          class="fg"
          [attr.class]="uploadProgress === 100 ? 'fg complete-pulse' : 'fg'"
          [attr.stroke-dashoffset]="getStrokeOffset(uploadProgress)"
        ></circle>
      </svg>
      <div
  [attr.class]="uploadProgress === 100 ? 'percent-label completed' : 'percent-label'"
>
  {{ uploadProgress }}%
</div>
    </div>
    <button class="cancel-button" (click)="cancelUpload()">Cancel</button>
  </div>
</div>

<!-- File Input -->
<wb-file-input
  #uploader
  [disabled]="spinner"
  accept=".zip"
  name="my-file"
  class="spacing-s"
>
  <span slot="title">
    Drag & Drop your files here or
    <wb-link variant="inline">Browse</wb-link>
  </span>
  <span slot="description">Supports .zip files</span>
</wb-file-input>
